import { billsActionTypes } from './billsActionTypes';
import { batuActionTypes } from './batuActionTypes';
import { uiActionTypes } from './uiActionTypes';
import { uxSurveyActionTypes } from './uxSurveyActionTypes';

export const ActionType = {
  ...billsActionTypes,
  ...batuActionTypes,
  ...uiActionTypes,
  ...uxSurveyActionTypes,
};
